import Button from "components/base/Button";
import { Input, NativeDatePicker, Select, Text } from "components/base/Form";
import { useState } from "react";

const WAREHOUSES = ["CHINA", "US", "ALC", "CHARLES_KENDLE"];

const GearInventoryForm = ({ initialValue, saveHandler }) => {
  const [state, setState] = useState(
    initialValue || {
      warehouseName: WAREHOUSES[0],
      date: new Date().toISOString().split("T")[0],
      inout: "IN",
      qty: 1,
      notes: "",
    },
  );

  return (
    <div>
      <div className="-mx-2">
        <table>
          <tbody>
            <tr>
              <td>Warehouse</td>
              <td className="w-full">
                <Select
                  value={state.warehouseName}
                  onChange={(e) =>
                    setState({ ...state, warehouseName: e.target.value })
                  }
                >
                  {WAREHOUSES.map((w) => (
                    <option key={w} value={w}>
                      {w}
                    </option>
                  ))}
                </Select>
              </td>
            </tr>
            <tr>
              <td>Date:</td>
              <td>
                <NativeDatePicker
                  value={state.date}
                  onChange={(e) => setState({ ...state, date: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td>Quantity:</td>
              <td>
                <Select
                  className="mr-3"
                  value={state.inout}
                  onChange={(e) =>
                    setState({ ...state, inout: e.target.value })
                  }
                >
                  <option value="IN">IN</option>
                  <option value="OUT">OUT</option>
                </Select>
                <Input
                  className="text-center"
                  min={1}
                  type="number"
                  value={state.qty}
                  onChange={(e) => setState({ ...state, qty: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td>Notes:</td>
              <td>
                <Text
                  value={state.notes}
                  onChange={(e) =>
                    setState({ ...state, notes: e.target.value })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-6 flex justify-between items-center">
        <Button primary onClick={() => saveHandler(state)}>
          Save
        </Button>
        {state.id && (
          <Button
            danger
            onClick={() => {
              if (
                window.confirm("Are you sure you want to delete this record?")
              ) {
                saveHandler({ ...state, delete: true });
              }
            }}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  );
};

export default GearInventoryForm;
